// Constants for components

export const ICON_COLORS = {
  slate: ["bg-slate-400", "text-slate-700"],
  blue: ["bg-sky-400 border-none", "text-sky-100"],
  yellow: ["bg-orange-200", "text-orange-700"],
  amber: ["bg-amber-200", "text-amber-700"],
  lime: ["bg-lime-200", "text-lime-700"],
  indigo: ["bg-violet-200", "text-violet-700"],
  pink: ["bg-pink-200", "text-pink-700"],
  rose: ["bg-white", "text-rose-400"],
  gray: ["bg-gray-200", "text-gray-600"],
  stone: ["bg-stone-200", "text-stone-700"],
  neutral: ["bg-neutral-200", "text-neutral-700"],
  blue_fill: ["bg-blue-400 border-white border", "text-blue-100"],
};

export const BUTTON_COLORS = {
  slate: ["bg-slate-400", "text-slate-700"],
  blue: ["bg-blue-400", "text-white", "border-blue-400"],
  sky: ["bg-sky-100", "text-sky-800"],
  yellow: ["bg-orange-200", "text-orange-700"],
  amber: ["bg-amber-200", "text-gray-700"],
  lime: ["bg-lime-200", "text-lime-700"],
  indigo: ["bg-violet-200", "text-violet-700"],
  pink: ["bg-pink-200", "text-pink-700"],
  rose: ["bg-rose-200", "text-rose-700"],
  gray: ["bg-gray-200", "text-gray-700"],
  stone: ["bg-stone-200", "text-stone-700"],
  black: ["bg-neutral-800", "text-neutral-100"],
};

export const BUTTON_COLORS_DARK = {
  slate: ["bg-slate-400", "text-slate-700"],
  blue: ["bg-blue-500", "text-sky-100", "border-sky-400"],
  sky: ["bg-sky-500", "text-sky-100", "border-sky-700"],
  yellow: ["bg-orange-200", "text-orange-700"],
  amber: ["bg-amber-300", "text-amber-800"],
  lime: ["bg-lime-200", "text-lime-700"],
  indigo: ["bg-violet-200", "text-violet-700"],
  pink: ["bg-pink-200", "text-pink-700"],
  rose: ["bg-rose-200", "text-rose-700"],
  gray: ["bg-gray-200", "text-gray-700"],
  stone: ["bg-stone-200", "text-stone-700"],
};
